import { BrokerageUserSearchRequestQuery } from '@lio/api-types';

export const getBrokerageUsersQuery = ({
  pageLimit,
  pageOffset,
  sort,
  searchText,
  role,
}: BrokerageUserSearchRequestQuery) => {
  const query = new URLSearchParams();
  if (pageLimit !== undefined) {
    query.append('pageLimit', String(pageLimit));
  }
  if (pageOffset !== undefined) {
    query.append('pageOffset', String(pageOffset));
  }
  if (sort) {
    query.append('sort', sort.toString());
  }
  if (searchText) {
    query.append('searchText', searchText.toString());
  }
  if (role) {
    query.append('role', role.toString());
  }
  return query.toString();
};
